var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.overlay}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.overlay = false}}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.color}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }